var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMelodic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 56,
    viewBox: "0 0 41 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 11.111C21 17.2474 16.299 22.222 10.5 22.222C4.70102 22.222 0 17.2474 0 11.111C0 4.97455 4.70102 0 10.5 0C16.299 0 21 4.97455 21 11.111ZM41 39.6821C41 48.1562 34.5081 55.0259 26.5 55.0259C18.4919 55.0259 12 48.1562 12 39.6821C12 31.208 18.4919 24.3384 26.5 24.3384C34.5081 24.3384 41 31.208 41 39.6821ZM33 19.0474C36.3137 19.0474 39 16.2048 39 12.6982C39 9.19171 36.3137 6.34912 33 6.34912C29.6863 6.34912 27 9.19171 27 12.6982C27 16.2048 29.6863 19.0474 33 19.0474Z",
    fill: "#B872FC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMelodic);
export default __webpack_public_path__ + "static/media/melodic.937797f52e0698c4845e0a0b2acdd6e7.svg";
export { ForwardRef as ReactComponent };